import React, { useContext, useState } from "react";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import wellbeinglogo from "../assets/images/PrivateStockLogo.png";
import ApiConfig from "../api/ApiConfig";
import { simplePostCall } from "../api/ApiServices";
import { AppContext } from "../context/AppContext";
import swal from "sweetalert";

const Login = ({ setLoggedIn }) => {
  const [validated, setValidated] = useState(false);
  const { setCustomerData } = useContext(AppContext);

  const [userCredentials, setUserCredentials] = useState({
    email: "",
    password: "",
  });

  console.log("userCredentials", userCredentials);
  const handleSubmit = (event) => {
    // const form = event.currentTarget;
    // if (form.checkValidity() === false) {
    //   event.preventDefault();
    // }
    // setValidated(true);
  };

  const login = () => {
    simplePostCall(ApiConfig.LOGIN, JSON.stringify({ ...userCredentials }))
      .then((res) => {
        // console.log(res);
        if (res.result) {
          let data = res?.user_details;
          if (data.role === "App_user") {
            swal({
              text: "please contact administrator",
              icon: "warning",
              dangerMode: true,
            });
          } else {
            console.log(data.auth_token);

            localStorage.setItem("auth_token", data.auth_token);
            localStorage.setItem("customer_id", data?.id);
            localStorage.setItem("role", data.role);
            localStorage.setItem("email", data.email);
            localStorage.setItem("full_name", data.full_name);
            localStorage.setItem("dob", data.dob);
            localStorage.setItem("userDetails", JSON.stringify(data));
            localStorage.setItem("logedIn", true);
            setCustomerData({
              customer_id: data?.id,
              role: data.role,
              auth_token: data?.auth_token,
              full_name: data?.full_name,
              email: data?.email,
              dob: data?.dob,
            });

            setLoggedIn(true);
          }
        } else {
          swal({
            text: res.message,
            icon: "warning",
            dangerMode: true,
          });
        }
      })
      .catch((err) => {
        // setLoading(false);
        console.log(err);
      });
  };
  return (
    <main className="main-login">
      <div className="wrapper row">
        <div className="left col-md-8">
          <div className="logo">
            <img src={wellbeinglogo} alt="" style={{ width: "350px" }} />
          </div>
        </div>
        <div className="right col-md-4">
          <div className="inner-form">
            <div className="text-center mb-4 heading-login">
              <label htmlFor="">Welcome, Please enter your credentials</label>
            </div>
            <Form noValidate validated={validated}>
              <div className="mb-3">
                <Form.Control
                  required
                  type="email"
                  placeholder="Email Address"
                  value={userCredentials.email}
                  onChange={(e) => {
                    setUserCredentials({
                      ...userCredentials,
                      email: e.target.value,
                    });
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Your Email.
                </Form.Control.Feedback>
              </div>
              <div className="mb-4">
                <Form.Control
                  required
                  type="password"
                  value={userCredentials.password}
                  onChange={(e) => {
                    setUserCredentials({
                      ...userCredentials,
                      password: e.target.value,
                    });
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter your password.
                </Form.Control.Feedback>
              </div>
              <div className="login-btn-main ">
                <Link to="#" className="innerLink">
                  <button className="cx-btn-1" onClick={login}>
                    Login
                  </button>
                </Link>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Login;
